import { RfqTable } from "../DashboardList/components/Table/RfqTable";

const Home = () => {
  return <></>;
};

export default Home;
